module.exports = __webpack_public_path__ + "images/grey-calendar-8fb69f35.svg";